// Version-picker sentinel for "Current version"; the API models it as null.
export const CURRENT_VERSION = "current";

// Sentinel the subflow node's old ConfigSelect stored for "Current version";
// still present in persisted flow definitions.
export const LEGACY_CURRENT_VERSION = "latest";

export const versionIdForApi = (versionId: string | undefined | null) =>
  !versionId || versionId === CURRENT_VERSION ? null : versionId;
